export default __webpack_public_path__ + "static/media/p&g.799ca276.png";